<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="接单统计" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>需求状态:</label>
                <el-select v-model="searchForm.status" clearable :size="size" placeholder="请选择">
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="k-filter-option" v-if="searchForm.status == 2">
              <div class="k-select-area">
                <label>结单类型:</label>
                <el-select v-model="searchForm.order_type" clearable :size="size" placeholder="请选择">
                  <el-option
                    v-for="item in order_typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="k-filter-option">
              <div class="k-select-area">
                <label>日期:</label>
                <el-date-picker
                  align="center"
                  v-model="searchForm.date"
                  type="daterange"
                  :size="size"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束"
                  @change="doSearch"
                  :picker-options="pickerOptions0"
                ></el-date-picker>
              </div>
            </div>

            <el-button :size="size" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-con">
                <el-table :data="tableData.data" border style="width: 100%">
                  <el-table-column fixed="left" prop="uid" label="用户ID" min-width="100"></el-table-column>
                  <el-table-column prop="nick_name" label="用户名称" min-width="200"></el-table-column>
                  <el-table-column prop="role" label="接单角色" min-width="200">
                    <template slot-scope="scope">
                      <el-tag size="mini" v-if="scope.row.role == 1">编导</el-tag>
                      <el-tag size="mini" v-if="scope.row.role == 2">剪辑</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="photo" label="实拍单数" min-width="200"></el-table-column>
                  <el-table-column prop="cutting" label="剪辑单数" min-width="200"></el-table-column>
                  <el-table-column prop="editting" label="改单数" min-width="200"></el-table-column>
                  <el-table-column prop="needNum" label="参与需求数" width="200"></el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      wrapper: false,
      addFormVisiable: false,
      titleFormVisiable: false,
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',
      projects: [],

      searchForm: {
        date: '',
        status: '1',
        order_type: ''
      },
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      statusOptions: [
        {
          value: '1',
          label: '接单'
        },
        {
          value: '2',
          label: '结单'
        }
      ],
      order_typeOptions: [
        {
          value: '1',
          label: '手动结单'
        },
        {
          value: '2',
          label: '上传结单'
        }
      ],

      pickerOptions0: {
        disabledDate: function(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    //搜索
    searchList: function() {
      var params = this.makeParams()
      this.handleSearch(params)
    },

    // 执行查询
    doSearch: function(event) {
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())
      this.$router.push({ path: this.$route.path, query: query })
    },

    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },

    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(this.searchForm, val)
    },

    // 公共请求接口
    handleSearch: function(params, page, prop, order) {
      this.loading = true
      var param = Object.assign({}, params)
      param['page'] = page ? page : 1
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'
      this.$api.post('need/table', param, res => {
        if (res.code == 0) {
          this.tableData.data = res.data
          this.$message({
            showClose: true,
            message: '查询列表信息成功！',
            type: 'success'
          })
        }
      })
    },
    // 生成查询参数
    makeParams: function(query, data) {
      var params = {}
      params['status'] = this.searchForm.status
      params['date'] = this.searchForm.date
      if (this.searchForm.status == 1) {
        this.searchForm.order_type = ''
      }
      params['order_type'] = this.searchForm.order_type
      this.searchForm = params
      return params
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = this.makeParams(to.query)
    this.handleSearch(params)
    next()
  },
  mounted: function() {
    var params = this.makeParams()
    this.handleSearch(params)
  }
}
</script>